<script>
import axios from 'axios'
import appConfig from '@src/app.config'
import DatePicker from 'vue2-datepicker'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'



export default {
  components: { Layout, PageHeader,DatePicker },
  page: {
    title: 'ST - Contribuyentes',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {  
      exitoso:null ,  
      title: 'Contribuyentes',
      data : null,    
      fields: [
        
        { key: 'idPago', sortable: false,  label:"Folio" },
        { key: 'concepto', sortable: false,  label:"Concepto" },
        { key: 'nombre', sortable: true,label:"Razón Social" },
        { key: 'descripcion', sortable: false,  label:"Descripcion" },        
        { key: 'fecha', sortable: false,  label:"Fecha" },
        { key: 'usuario', sortable: false,  label:"Usuario" },
        { key: 'importe', sortable: false,  label:"Importe" },
        { key: 'idPrint', sortable: false,  label:"" },
        
      ],
      form:{
          contribuyente:'',
          fechaInicio:'',
          fechaFin: '',
      },
      importeTotal:'0.00',
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totalRows: 0,
      isBusy: false,
      contexto:{},
      items: [
        {
          text: 'Sistema Tributario',
          href: '/',
        },
        {
          text: 'Contribuyentes',
          active: true,
        },
      ]
    }
  },
  computed:{
  
  },
  mounted(){
    this.exitoso = this.$route.params.exito;
   
  },
   methods:{
     generarReporte(){
       this.$refs.tablaContribuyentes.refresh();
     },     
     cargarListado(ctx){
       this.busy= true;      
       
       ctx.contribuyente = this.form.contribuyente;
       if( this.form.fechaInicio !== ''){
         ctx.fechaInicio = this.formatDateServer(this.form.fechaInicio);
       ctx.fechaFin = this.formatDateServer(this.form.fechaFin);
       }
       if( this.form.fechaFin !== ''){         
       ctx.fechaFin = this.form.fechaFin;
       }
       

       let promise = axios
            .get(appConfig.recursosApi.reportes +"/contribuyente",{params: ctx  })
       return promise
            .then((response) => {
              this.totalRows = response.data.listado.totalRegistros;
                this.data = response.data.listado.result;                
                this.importeTotal= response.data.importeTotal;
                this.isBusy = false;
                return response.data.listado.result;
            })
             .catch(()=>  {
               this.isBusy = false;
               return []
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
               //  this.$router.push('/500') ;
            }); 
     },    
    generarReporteF(tipo) {
      var url = appConfig.recursosApi.urlPrincipal+'/reportes/contribuyente/reporte?tipo='+tipo+'&contribuyente=' + this.form.contribuyente;
       if( this.form.fechaInicio !== ''){
         url =url +"&fechaInicio=" + this.formatDate(this.form.fechaInicio);       
       }
       if( this.form.fechaFin !== ''){
          url =url +"&fechaFin=" + this.formatDate(this.form.fechaFin);
      } 

      window.open(
        url,
        '_blank',
        'location=yes,height=570,width=520,scrollbars=yes,status=yes'
      )
    },
    formatDate(date) {
      if (date === null) {
        return null
      }
      var fecha = new Date(date)
      var month = '' + (fecha.getMonth() + 1)
      var day = '' + fecha.getDate()
      var year = fecha.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [day, month, year].join('-')
    },
    imprimir(id){
         window.open(
              appConfig.recursosApi.urlPrincipal +'/Reportes/recibo/'+ id,
              '_blank',
              'location=yes,height=570,width=520,scrollbars=yes,status=yes'
            );

     },
     formatDateServer(date) {
      if (date === null) {
        return null
      }
      var fecha = new Date(date)
      var month = '' + (fecha.getMonth() + 1)
      var day = '' + fecha.getDate()
      var year = fecha.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return new Date([year, month, day].join('-') +"T00:00:00.000-08:00"); 
    }
   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
             <b-alert v-if="exitoso"
            show
            dismissible
            class="bg-success text-white border-0"
          >Se ha guardado la información del contribuyente.</b-alert>
            <div class="row"> 
                <div class="col-8">
                       <h4 class="header-title"></h4>
                        <p class="text-muted font-13 mb-4"></p>
                </div>                
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label> Contribuyente </label>
                <input
                  v-model="form.contribuyente"
                  type="text"
                  name="descripcion"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <div class="form-group col-md-2">
                 <label for="name">
                      Inicio
                    </label>
                <date-picker  
                        v-model="form.fechaInicio"
                        :first-day-of-week="1" 
                        format="DD/MM/YYYY"
                        lang="es"></date-picker>
              </div>
              <div class="form-group col-md-2">
                 <label for="name">
                      Fin
                    </label>
                <date-picker  
                        v-model="form.fechaFin"
                        :first-day-of-week="1" 
                        format="DD/MM/YYYY"
                        lang="es"></date-picker>
              </div>
              <div class="form-group col-md-sm">
                <br />
                <label></label>
                <button
                      id="link-eliminar"
                      type="button"
                      class="btn btn-success m-l-5 ml-1 btn-sm btn-rounded"
                      @click="generarReporte"
                    >
                       Generar
                </button>
              </div>
              <div class="form-group col-md-2">
                <br />
                <label></label>
                <button
                      id="link-eliminar"
                      type="button"
                      class="btn btn-primary m-l-5 ml-1 btn-sm btn-rounded" 
                      @click="generarReporteF(0)"                     
                    >
                       PDF
                </button>
                <button
                      id="link-eliminar"
                      type="button"
                      class="btn btn-primary m-l-5 ml-1 btn-sm btn-rounded"
                      @click="generarReporteF(1)"                     
                    >
                       Excel
                </button>
              </div>              
            </div>
      
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp; Registros
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                   <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
              ref="tablaContribuyentes"
              :busy.sync="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :items="cargarListado"
              :fields="fields"
                responsive="sm"
                
              >
               <template v-slot:table-busy>
                 <div class="text-center text-success">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
              </template>
              <template v-slot:cell(idPrint)="{ item }">
                  <button
                    id="link-print"
                    class="btn btn-primary m-l-5 ml-1 btn-md btn-rounded"
                    @click="imprimir(item.idPago)"
                  >
                    <i class="fe-printer"></i>
                  </button>
                  <b-tooltip target="link-print">Imprimir </b-tooltip>
                </template>              
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                   
                   <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group text-right m-b-0">
              <h1>
                <span class="badge bg-danger"
                  > {{ importeTotal }}</span
                ></h1
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>